export const pagingMetadataToCursorResponse = pagingMetadata => {
  var _pagingMetadata$curso;
  return pagingMetadata ? {
    cursor: ((_pagingMetadata$curso = pagingMetadata.cursors) == null ? void 0 : _pagingMetadata$curso.next) || null,
    count: pagingMetadata.count,
    total: pagingMetadata.total,
    hasNext: pagingMetadata.hasNext ?? false
  } : {
    cursor: null
  };
};
//# sourceMappingURL=PagingUtils.js.map